import { createContext, useState, useEffect, ReactNode, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { getShowSets } from '~/app/store/debug'
import { tileEntityAllIdsSelector, tileEntityByIdSelector } from '~/app/store/tileEntity'
import { getColorForSet } from './utils'

interface SetHighlightingContextType {
  setColorMap: Map<string, string>
  getSetColor: (set: string) => string | undefined
}

export const SetHighlightingContext = createContext<SetHighlightingContextType | undefined>(undefined)

interface SetHighlightingProviderProps {
  children: ReactNode
}

export const SetHighlightingProvider: React.FC<SetHighlightingProviderProps> = ({ children }) => {
  const showSets = useSelector(getShowSets)
  const tileEntityIds = useSelector(tileEntityAllIdsSelector)
  const tileEntityById = useSelector(tileEntityByIdSelector)
  const [setColorMap, setSetColorMap] = useState<Map<string, string>>(new Map())

  const allTileEntities = useMemo(() => {
    return tileEntityIds.map(tileEntityById)
  }, [tileEntityIds, tileEntityById])

  useEffect(() => {
    if (showSets && allTileEntities.length > 0) {
      const uniqueSets = new Set<string>()
      allTileEntities.forEach((entity) => {
        if (entity?.rankingSet) {
          uniqueSets.add(entity.rankingSet)
        }
      })

      const setsArray = Array.from(uniqueSets)
      const newMap = new Map<string, string>()

      setsArray.forEach((set) => {
        getColorForSet(set, newMap)
      })

      setSetColorMap(newMap)
    }
  }, [allTileEntities, showSets])

  const getSetColor = (set: string): string | undefined => {
    return setColorMap.get(set)
  }

  return <SetHighlightingContext.Provider value={{ setColorMap, getSetColor }}>{children}</SetHighlightingContext.Provider>
}
